import { render, staticRenderFns } from "./IdentityDocumentListView.vue?vue&type=template&id=62254d0f&scoped=true&"
import script from "./IdentityDocumentListView.vue?vue&type=script&lang=js&"
export * from "./IdentityDocumentListView.vue?vue&type=script&lang=js&"
import style0 from "./IdentityDocumentListView.vue?vue&type=style&index=0&id=62254d0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62254d0f",
  null
  
)

export default component.exports